import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: '[lookup-notfound-template]' })
export class LookupNotFoundTemplateDirective {
  constructor(public template: TemplateRef<any>) { }
}